import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="image-generation"
export default class extends Controller {
  static targets = ["width", "height"]
  static values = {
    ratio: String,
    width: Number,
    height: Number
  }

  connect() {
    // Initialize any necessary state
  }

  updateDimensions(event) {
    const button = event.currentTarget
    const ratio = button.dataset.imageGenerationRatioValue
    const width = parseInt(button.dataset.imageGenerationWidthValue)
    const height = parseInt(button.dataset.imageGenerationHeightValue)

    // Update hidden fields
    if (this.hasWidthTarget) this.widthTarget.value = width
    if (this.hasHeightTarget) this.heightTarget.value = height

    // Update visual selection
    this.element.querySelectorAll('.aspect-ratio-button').forEach(btn => {
      btn.classList.remove('selected')
    })
    button.classList.add('selected')
  }
}